import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types';
import { HeicData } from '../types/api/HeicData';

const URL = '/heic-convert'

class HeicConvertService {
  static convert(
    data: FormData,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<HeicData>> {
    return axios.post(URL, data, config);
  }

  static isHeic(buffer: Uint8Array): boolean {
    if (!buffer || buffer.length < 12) {
      return false;
    }

    // Check for ISO Base Media File Format (ISOBMFF) structure
    // HEIC files start with an 'ftyp' box

    // First 4 bytes are the box size (big-endian)
    // Next 4 bytes should be 'ftyp' (0x66747970)
    if (buffer[4] !== 0x66 || buffer[5] !== 0x74 || buffer[6] !== 0x79 || buffer[7] !== 0x70) {
      return false;
    }

    // Check if we have enough bytes to read the major brand
    if (buffer.length < 16) {
      return false;
    }

    // Get the box size to know how much data we have for brands
    const boxSize = (buffer[0] << 24) | (buffer[1] << 16) | (buffer[2] << 8) | buffer[3];  

    // Sanity check: box size should be reasonable and not larger than buffer
    if (boxSize < 16 || boxSize > buffer.length) {
      return false;
    }

    // Major brand starts at byte 8, compatible brands start at byte 12
    // Check for HEIC-related brands in the available space
    const availableBytes = Math.min(boxSize, buffer.length);

    for (let i = 8; i < availableBytes - 3; i += 4) {
      // Check for HEIC brands: 'heic', 'heix', 'hevm', 'mif1'
      const brand = String.fromCharCode(buffer[i], buffer[i + 1], buffer[i + 2], buffer[i + 3]);

      if (brand === 'heic' || brand === 'heix' || brand === 'hevm' || brand === 'mif1') {
        return true;
      }
    }

    return false;
  }
}

export { HeicConvertService };
